module.exports = "https://trybtryb-legacy.web.app/img/ripped-special-mobile.a7a8d452.svg";